<template>
  <div
    v-loading="loading"
    element-loading-text="数据加载中……"
    element-loading-spinner="el-icon-loading"
  >
    <el-row type="flex" justify="space-around">
      <el-col :lg="14" :sm="24" :xs="24">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span><b>基本信息</b></span>
            <slot>
              <el-button
                icon="fa fa-share"
                style="float: right; margin-bottom: 0px"
                type="success"
                plain
                @click="share"
                >分享</el-button
              >
            </slot>
          </div>
          <el-form ref="postForm" :model="form">
            <div v-if="!isMb">
              <el-row aria-colspan="5">
                <el-col :lg="16" :sm="24" :xs="24">
                  <el-form-item label="姓名:" prop="name" required>
                    <span>{{ form.name }}</span>
                  </el-form-item>
                  <el-form-item label="性别:" prop="sex" required>
                    <span>{{ form.sex }}</span>
                  </el-form-item>
                  <el-form-item label="出生年月日:" prop="birthday" required>
                    <span>{{ form.birthday }}</span>
                  </el-form-item>
                  <el-form-item label="注册手机号:" prop="mobile" required>
                    <span>{{ form.mobile }}</span>
                  </el-form-item>
                  <el-form-item label="身份证号:" prop="cardNumber" required>
                    <span>{{ form.cardNumber }}</span>
                  </el-form-item>
                </el-col>
                <el-col :lg="8" :sm="24" :xs="24">
                  <el-upload
                    title="照片上传"
                    class="avatar-uploader"
                    :action="pictureUploadAction"
                    :headers="headers"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :before-upload="beforeAvatarUpload"
                    disabled
                  >
                    <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-col>
              </el-row>
            </div>
            <!--            手机端 ----------------------------------------->
            <div v-else>
              <el-row>
                <el-col aria-rowspan="4" span="12">
                  <el-row
                    ><el-form-item label="姓名:" prop="name" required>
                      <span>{{ form.name }}</span>
                    </el-form-item></el-row
                  >
                  <el-row
                    ><el-form-item label="性别:" prop="sex" required>
                      <span>{{ form.sex }}</span>
                    </el-form-item></el-row
                  >
                  <el-row
                    ><el-form-item label="手机号:" prop="mobile" required>
                      <span>{{ form.mobile }}</span>
                    </el-form-item></el-row
                  >
                  <el-row
                    ><el-form-item label="身份证:" prop="cardNumber" required>
                      <span>{{ form.cardNumber }}</span>
                    </el-form-item></el-row
                  >
                </el-col>
                <el-col span="12">
                  <el-upload
                    title="照片上传"
                    class="avatar-uploader"
                    :action="pictureUploadAction"
                    :headers="headers"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :before-upload="beforeAvatarUpload"
                    disabled
                  >
                    <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-col>
              </el-row>
            </div>
            <el-row v-if="isMb"
              ><el-form-item label="出生日期:" prop="cardNumber" required>
                <span>{{ form.birthday }}</span>
              </el-form-item></el-row
            >
            <el-row>
              <el-col :lg="12" :sm="24" :xs="24">
                <el-form-item
                  label="政治面貌:"
                  prop="politicallyState"
                  required
                >
                  <span>{{ form.politicallyState }}</span>
                </el-form-item>
              </el-col>
              <el-col :lg="12" :sm="24" :xs="24">
                <el-form-item label="籍贯:" prop="birthdayLocal" required>
                  <span>{{ form.birthdayLocal }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col span="12">
                <el-form-item label="民族:" prop="nation" required>
                  <span>{{ form.nation }}</span>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item label="婚否:" prop="married" required>
                  <span>{{ form.married }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col span="12">
                <el-form-item label="出生地:" prop="placeOfOrigin" required>
                  <span>{{ form.placeOfOrigin }}</span>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item label="高考户籍所在地:" prop="married" required>
                  <span>{{ form.nativePlace }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col span="24">
                <el-form-item label="邮箱:" prop="email" required>
                  <span>{{ form.email }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col span="12">
                <el-form-item label="身高:" prop="high">
                  <span>{{ form.high }} cm</span>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item label="体重:" prop="weight">
                  <span>{{ form.weight }} kg</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :lg="12" :sm="24" :xs="24">
                <el-form-item label="爱好:" prop="hobby">
                  <span>{{ form.hobby }}</span>
                </el-form-item>
              </el-col>
              <el-col :lg="12" :sm="24" :xs="24">
                <el-form-item label="特长:" prop="speciality">
                  <span>{{ form.speciality }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col span="12">
                <el-form-item
                  label="国(境)外留学情况:"
                  prop="hasBroadExp"
                  required
                >
                  <span>{{ form.hasBroadExp }}</span>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item label="国籍:" prop="nationality" required>
                  <span>{{ form.nationality }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col span="24">
                <el-form-item label="配偶国籍:" prop="spouseNationality">
                  <span>{{ form.spouseNationality }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <div style="margin-bottom: 10px">
              <el-row>
                <el-col :span="20"
                  ><span class="spanTitle">家庭成员</span>
                </el-col>
              </el-row>
            </div>
            <el-card>
              <el-row>
                <el-col span="24">
                  <el-form-item
                    label="与应聘单位干部职工存在亲属关系:"
                    prop="deptRelations"
                    label-width="300px"
                    label-style="{ textAlign: 'left' }"
                    required
                  >
                    <span>{{ form.deptRelations }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col span="24">
                  <el-form-item
                    label="是否与院内干部职工存在亲属关系:"
                    prop="yardRelations"
                    label-width="300px"
                    label-style="{ textAlign: 'left' }"
                    required
                  >
                    <span>{{ form.yardRelations }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <div style="overflow: auto; height: 240px">
                <zr-table
                  ref="familyTable"
                  height-fixed
                  class="user-box"
                  selection-type="single"
                  :data="form.familyInfo"
                  :columns="familyColumns"
                  table-height="200px"
                  style="overflow: auto"
                  stripe
                >
                  <template v-slot:relationship="{ row }">
                    <!--                    <el-select v-model="row['relationship']">-->
                    <!--                      <el-option-->
                    <!--                          v-for="item in basicFamily"-->
                    <!--                          :key="item.code"-->
                    <!--                          :label="item.name"-->
                    <!--                          :value="item.code"-->
                    <!--                          readonly-->
                    <!--                      >-->
                    <!--                      </el-option>-->
                    <!--                    </el-select>-->
                    <span>{{ row["relationship"] }}</span>
                  </template>
                  <template v-slot:name="{ row }">
                    <!--                    <el-input-->
                    <!--                        v-model="row['name']"-->
                    <!--                        size="mini"-->
                    <!--                        maxlength="10"-->
                    <!--                        readonly-->
                    <!--                    ></el-input>-->
                    <span>{{ row["name"] }}</span>
                  </template>
                  <template v-slot:sex="{ row }">
                    <!--                    <el-select v-model="row['sex']" disabled>-->
                    <!--                      <el-option-->
                    <!--                          v-for="item in basicSex"-->
                    <!--                          :key="item.code"-->
                    <!--                          :label="item.name"-->
                    <!--                          :value="item.code"-->
                    <!--                      >-->
                    <!--                      </el-option>-->
                    <!--                    </el-select>-->
                    <span>{{ renderData(row["sex"], basicSex) }}</span>
                  </template>
                  <template v-slot:birthDay="{ row }">
                                        <el-date-picker
                                            v-model="row['birthDay']"
                                            type="date"
                                            format="yyyy-MM-dd"
                                            value-format="yyyy-MM-dd"
                                            placeholder="选择出生日期"
                                            readonly
                                        >
                                        </el-date-picker>
                  </template>
                  <template v-slot:nation="{ row }">
                    <!--                    <el-select v-model="row['nation']" clearable filterable disabled>-->
                    <!--                      <el-option-->
                    <!--                          v-for="item in nationArray"-->
                    <!--                          :key="item.code"-->
                    <!--                          :label="item.name"-->
                    <!--                          :value="item.code"-->
                    <!--                      >-->
                    <!--                      </el-option>-->
                    <!--                    </el-select>-->
                    <span>{{ renderData(row["nation"], nationArray) }}</span>
                  </template>
                  <template v-slot:politicallyState="{ row }">
                    <!--                    <el-select-->
                    <!--                        v-model="row['politicallyState']"-->
                    <!--                        clearable-->
                    <!--                        filterable-->
                    <!--                        disabled-->
                    <!--                    >-->
                    <!--                      <el-option-->
                    <!--                          v-for="item in basicPoliticallyState"-->
                    <!--                          :key="item.code"-->
                    <!--                          :label="item.name"-->
                    <!--                          :value="item.code"-->
                    <!--                      >-->
                    <!--                      </el-option>-->
                    <!--                    </el-select>-->
                    <span>{{ renderData(row["politicallyState"], basicPoliticallyState) }}</span>
                  </template>
                  <template v-slot:deptAndHeadship="{ row }">
                    <!--                    <el-input-->
                    <!--                        v-model="row['deptAndHeadship']"-->
                    <!--                        size="mini"-->
                    <!--                        maxlength="500"-->
                    <!--                        clearable-->
                    <!--                        readonly-->
                    <!--                    ></el-input>-->
                    <span>{{ row["deptAndHeadship"] }}</span>
                  </template>
                  <template v-slot:workInfo="{ row }">
                    <span>{{ row["workInfo"] }}</span>
                  </template>
                </zr-table>
              </div>
            </el-card>
            <!--            <el-row>-->
            <!--              <el-col span="24">-->
            <!--                <el-form-item label="家庭主要成员信息:" prop="familyMember">-->
            <!--                  <el-col :lg="20" :sm="16" :xs="16">-->
            <!--                    <el-input-->
            <!--                      v-model="form.familyMember"-->
            <!--                      type="textarea"-->
            <!--                      readonly-->
            <!--                      :rows="5"-->
            <!--                      :autosize="{ minRows: 5, maxRows: 20 }"-->
            <!--                      placeholder="有海外关系的必须注明!"-->
            <!--                    ></el-input>-->
            <!--                  </el-col>-->
            <!--                </el-form-item>-->
            <!--              </el-col>-->
            <!--            </el-row>-->
            <el-divider />
            <div v-if="isProfessionTech || isTechnique ? true : false">
              <el-row>
                <el-col :span="20"
                  ><span class="spanTitle">教育背景和工作经历</span>
                </el-col>
                <el-col :span="4"
                  ><el-tag style="float: right">{{
                    isProfessionTech ? "专技类" : "技能类"
                  }}</el-tag></el-col
                >
              </el-row>
              <el-divider />
              <!--专技类-->
              <div v-if="isProfessionTech">
                <el-form-item
                  label="最高学历:"
                  prop="topDegree"
                  style="font-weight: bold"
                  required
                >
                  <span>{{ form.topDegree }}</span>
                </el-form-item>
                <el-card
                  v-for="row in form.experienceList"
                  :key="row.phase"
                  style=""
                >
                  <div slot="header">
                    <span>{{ row.phase }}</span>
                  </div>
                  <el-row>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="开始日期:" prop="startDate" required>
                        <span>{{ row.startDate }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="结束日期:" prop="endDate" required>
                        <span>{{ row.endDate }}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="毕业单位:" prop="university" required>
                        <span>{{ row.university }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="学院/系:" prop="institutions">
                        <span>{{ row.institutions }}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="一级学科:" prop="studyField" required>
                        <span>{{ row.studyField }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="毕业专业:" prop="majorCourse" required>
                        <span>{{ row.majorCourse }}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <!--                    <el-col :lg="12" :sm="24" :xs="24">-->
                    <!--                      <el-form-item label="专业:" prop="totalNumber">-->
                    <!--                        <span>{{ row.totalNumber }}</span>-->
                    <!--                      </el-form-item>-->
                    <!--                    </el-col>-->
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="专业总人数:" prop="totalNumber">
                        <span>{{ row.totalNumber }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="综合排名:" prop="rankNum">
                        <span>{{ row.rankNum }}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :lg="24" :sm="24" :xs="24">
                      <el-form-item label="学习形式:" prop="learningShape" required>
                        <span>{{ row.learningShape }}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <!--                  <el-row>-->
                  <!--                    <el-col :lg="12" :sm="24" :xs="24">-->
                  <!--                      <el-form-item label="学习形式:" prop="learningShape">-->
                  <!--                        <span>{{ row.learningShape }}</span>-->
                  <!--                      </el-form-item>-->
                  <!--                    </el-col>-->
                  <!--                    <el-col :lg="12" :sm="24" :xs="24">-->
                  <!--                      <el-form-item label="备注:" prop="remark">-->
                  <!--                        <span>{{ row.remark }}</span>-->
                  <!--                      </el-form-item>-->
                  <!--                    </el-col>-->
                  <!--                  </el-row>-->
                  <!--                  <el-row-->
                  <!--                    v-if="-->
                  <!--                      row.disciplineEvaluation &&-->
                  <!--                      row.disciplineEvaluation.length > 0-->
                  <!--                    "-->
                  <!--                  >-->
                  <!--                    <el-col :lg="24" :sm="24" :xs="24">-->
                  <!--                      <el-form-item-->
                  <!--                        label="学科评估:"-->
                  <!--                        prop="disciplineEvaluation"-->
                  <!--                      >-->
                  <!--                        <span>{{ row.disciplineEvaluation }}</span>-->
                  <!--                      </el-form-item>-->
                  <!--                    </el-col>-->
                  <!--                  </el-row>-->

                  <el-row>
                    <el-col :lg="24" :sm="24" :xs="24">
                      <el-form-item label="备注:" prop="remark">
                        <span>{{ row.remark }}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-card>
                <div
                  v-if="form.degreeList.length > 0"
                  style="font-weight: bold; margin-bottom: 10px"
                >
                  <span><font color="red">*</font><b>最高学位：</b> </span>
                  <span>{{ form.topDegreeName }}</span>
                </div>
                <el-card
                  v-for="row in form.degreeList"
                  :key="row.degreeName"
                  style=""
                >
                  <div slot="header">
                    <span>{{ row.degreeName }}</span>
                  </div>
                  <el-row>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="开始日期:" prop="startDate" required>
                        <span>{{ row.startDate.substring(0, 10) }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="结束日期:" prop="endDate" required>
                        <span>{{ row.endDate.substring(0, 10) }}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="学位授予单位:" prop="degreeDept" required>
                        <span>{{ row.degreeDept }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="学习形式:" prop="learningFormat" required>
                        <span>{{ row.learningFormat }}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="获学位学科:" prop="degreeScience" required>
                        <span>{{ row.degreeScience }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="获学位专业:" prop="degreeStudyField" required>
                        <span>{{ row.degreeStudyField }}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-card>
                <div style="margin-bottom: 10px">
                  <el-row>
                    <el-col :span="20"
                    ><span class="spanTitle">语言语种:</span>
                    </el-col>
                  </el-row>
                </div>
                <el-card>
                  <div style="overflow: auto; height: 240px">
                    <zr-table
                        ref="familyTable"
                        height-fixed
                        class="user-box"
                        selection-type="single"
                        :data="form.languageInfoList"
                        :columns="languageInfoColumns"
                        table-height="200px"
                        stripe
                    >
                      <template v-slot:languageClass="{ row }">
                        <span>{{row['languageClass']}}</span>
                      </template>
                      <template v-slot:languageCertificate="{ row }">
                        <span>{{row['languageCertificate']}}</span>
                      </template>
                      <template v-slot:languageScore="{ row }">
                        <span>{{row['languageScore']}}</span>
                      </template>
                    </zr-table>
                  </div>
                </el-card>
                <div style="margin-bottom: 10px">
                  <el-row>
                    <el-col :span="20"
                      ><span class="spanTitle">实习经历:</span>
                    </el-col>
                  </el-row>
                </div>
                <el-card>
                  <div style="overflow: auto; height: 240px">
                    <zr-table
                      ref="familyTable"
                      height-fixed
                      class="user-box"
                      selection-type="single"
                      :data="form.parcticeLiveList"
                      :columns="parcticeLiveColumns"
                      table-height="200px"
                      stripe
                    >
                      <template v-slot:startLiveTime="{ row }">
                        <el-date-picker
                          v-model="row['startLiveTime']"
                          type="date"
                          placeholder="选择开始日期"
                          readonly
                        >
                        </el-date-picker>
                      </template>
                      <template v-slot:endLiveTime="{ row }">
                        <el-date-picker
                          v-model="row['endLiveTime']"
                          type="date"
                          placeholder="选择结束日期"
                          readonly
                        >
                        </el-date-picker>
                      </template>
                      <template v-slot:companyName="{ row }">
<!--                        <el-input-->
<!--                          v-model="row['companyName']"-->
<!--                          size="mini"-->
<!--                          maxlength="32"-->
<!--                          readonly-->
<!--                        ></el-input>-->
                        <span>{{row['companyName']}}</span>
                      </template>
                      <template v-slot:location="{ row }">
<!--                        <el-input-->
<!--                          v-model="row['location']"-->
<!--                          size="mini"-->
<!--                          maxlength="32"-->
<!--                          readonly-->
<!--                        ></el-input>-->
                        <span>{{row['location']}}</span>
                      </template>
                      <template v-slot:workDeptName="{ row }">
<!--                        <el-input-->
<!--                          v-model="row['workDeptName']"-->
<!--                          size="mini"-->
<!--                          readonly-->
<!--                          maxlength="500"-->
<!--                        ></el-input>-->
                        <span>{{row['workDeptName']}}</span>
                      </template>
                      <template v-slot:workPostName="{ row }">
<!--                        <el-input-->
<!--                          v-model="row['workPostName']"-->
<!--                          size="mini"-->
<!--                          readonly-->
<!--                          maxlength="500"-->
<!--                        ></el-input>-->
                        <span>{{row['workPostName']}}</span>
                      </template>
                      <template v-slot:achievement="{ row }">
<!--                        <el-input-->
<!--                          v-model="row['achievement']"-->
<!--                          size="mini"-->
<!--                          readonly-->
<!--                          maxlength="500"-->
<!--                          clearable-->
<!--                        ></el-input>-->
                        <span>{{row['achievement']}}</span>
                      </template>
                    </zr-table>
                  </div>
                </el-card>
                <div style="margin-bottom: 10px">
                  <el-row>
                    <el-col :span="20"
                      ><span class="spanTitle">工作经历:</span>
                    </el-col>
                  </el-row>
                </div>
                <el-card>
                  <div style="overflow: auto; height: 240px">
                    <zr-table
                      ref="familyTable"
                      height-fixed
                      class="user-box"
                      selection-type="single"
                      :data="form.workLiveList"
                      :columns="workLiveColumns"
                      table-height="200px"
                      stripe
                    >
                      <template v-slot:startLiveTime="{ row }">
                        <el-date-picker
                          v-model="row['startLiveTime']"
                          type="date"
                          placeholder="选择开始日期"
                          readonly
                        >
                        </el-date-picker>
                      </template>
                      <template v-slot:endLiveTime="{ row }">
                        <el-date-picker
                          v-model="row['endLiveTime']"
                          type="date"
                          placeholder="选择结束日期"
                          readonly
                        >
                        </el-date-picker>
                      </template>
                      <template v-slot:companyName="{ row }">
<!--                        <el-input-->
<!--                          v-model="row['companyName']"-->
<!--                          size="mini"-->
<!--                          maxlength="32"-->
<!--                          readonly-->
<!--                        ></el-input>-->
                        <span>{{row['companyName']}}</span>
                      </template>
                      <template v-slot:location="{ row }">
<!--                        <el-input-->
<!--                          v-model="row['location']"-->
<!--                          size="mini"-->
<!--                          readonly-->
<!--                          maxlength="32"-->
<!--                        ></el-input>-->
                        <span>{{row['location']}}</span>
                      </template>
                      <template v-slot:workDeptName="{ row }">
<!--                        <el-input-->
<!--                          v-model="row['workDeptName']"-->
<!--                          size="mini"-->
<!--                          readonly-->
<!--                          maxlength="500"-->
<!--                        ></el-input>-->
                        <span>{{row['workDeptName']}}</span>
                      </template>
                      <template v-slot:workPostName="{ row }">
<!--                        <el-input-->
<!--                          v-model="row['workPostName']"-->
<!--                          size="mini"-->
<!--                          readonly-->
<!--                          maxlength="500"-->
<!--                        ></el-input>-->
                        <span>{{row['workPostName']}}</span>
                      </template>
                      <template v-slot:achievement="{ row }">
<!--                        <el-input-->
<!--                          v-model="row['achievement']"-->
<!--                          size="mini"-->
<!--                          maxlength="500"-->
<!--                          readonly-->
<!--                          clearable-->
<!--                        ></el-input>-->
                        <span>{{row['achievement']}}</span>
                      </template>
                    </zr-table>
                  </div>
                </el-card>
                <div style="margin-bottom: 10px">
                  <el-row>
                    <el-col :span="20"
                      ><span class="spanTitle">科研项目经历:</span>
                    </el-col>
                  </el-row>
                </div>
                <el-card>
                  <div style="overflow: auto; height: 240px">
                    <zr-table
                      ref="familyTable"
                      height-fixed
                      class="user-box"
                      selection-type="single"
                      :data="form.projectLiveList"
                      :columns="projectLiveColumns"
                      table-height="200px"
                      stripe
                    >
                      <template v-slot:startLiveTime="{ row }">
                        <el-date-picker
                          v-model="row['startLiveTime']"
                          type="date"
                          readonly
                          placeholder="选择开始日期"
                        >
                        </el-date-picker>
                      </template>
                      <template v-slot:endLiveTime="{ row }">
                        <el-date-picker
                          v-model="row['endLiveTime']"
                          type="date"
                          readonly
                          placeholder="选择结束日期"
                        >
                        </el-date-picker>
                      </template>
                      <template v-slot:projectName="{ row }">
<!--                        <el-input-->
<!--                          v-model="row['projectName']"-->
<!--                          size="mini"-->
<!--                          readonly-->
<!--                          maxlength="32"-->
<!--                        ></el-input>-->
                        <span>{{row['projectName']}}</span>
                      </template>
                      <template v-slot:projectRole="{ row }">
<!--                        <el-input-->
<!--                          v-model="row['projectRole']"-->
<!--                          size="mini"-->
<!--                          readonly-->
<!--                          maxlength="32"-->
<!--                        ></el-input>-->
                        <span>{{row['projectRole']}}</span>
                      </template>
                      <template v-slot:companyName="{ row }">
<!--                        <el-input-->
<!--                          v-model="row['companyName']"-->
<!--                          size="mini"-->
<!--                          readonly-->
<!--                          maxlength="500"-->
<!--                        ></el-input>-->
                        <span>{{row['companyName']}}</span>
                      </template>
                      <template v-slot:achievement="{ row }">
<!--                        <el-input-->
<!--                          v-model="row['achievement']"-->
<!--                          size="mini"-->
<!--                          clearable-->
<!--                          readonly-->
<!--                          maxlength="500"-->
<!--                        ></el-input>-->
                        <span>{{row['achievement']}}</span>
                      </template>
                    </zr-table>
                  </div>
                </el-card>
                <el-row>
                  <el-col :lg="12" :sm="24" :xs="24">
                    <el-form-item
                      label="是否应届生:"
                      prop="education.freshGraduate"
                      required
                    >
                      <span>{{ form.education.freshGraduate }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :lg="12" :sm="24" :xs="24">
                    <el-form-item
                      label="计算机等级:"
                      prop="education.programLevel"
                    >
                      <span>{{ form.education.programLevel }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item label="主干课程:" prop="education.course" required>
                  <el-col :lg="20" :sm="16" :xs="16">
                    <el-input
                      v-model="form.education.course"
                      type="textarea"
                      readonly
                      :rows="5"
                      :autosize="{ minRows: 5, maxRows: 20 }"
                    ></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item
                  label="科研方向(专科，本科填写专业)::"
                  prop="education.researchOrientation"
                >
                  <el-col :lg="20" :sm="16" :xs="16">
                    <el-input
                      v-model="form.education.researchOrientation"
                      type="textarea"
                      readonly
                      :rows="5"
                      :autosize="{ minRows: 5, maxRows: 20 }"
                    ></el-input>
                  </el-col>
                </el-form-item>
                <!--                <el-form-item label="实习经历:" prop="education.internship">-->
                <!--                  <el-col :lg="20" :sm="16" :xs="16">-->
                <!--                    <el-input-->
                <!--                      v-model="form.education.internship"-->
                <!--                      type="textarea"-->
                <!--                      readonly-->
                <!--                      :rows="5"-->
                <!--                      :autosize="{ minRows: 5, maxRows: 20 }"-->
                <!--                    ></el-input>-->
                <!--                  </el-col>-->
                <!--                </el-form-item>-->
                <!--                <el-form-item label="工作经历:" prop="education.workexp">-->
                <!--                  <el-col :lg="20" :sm="16" :xs="16">-->
                <!--                    <el-input-->
                <!--                      v-model="form.education.workexp"-->
                <!--                      type="textarea"-->
                <!--                      readonly-->
                <!--                      :rows="5"-->
                <!--                      :autosize="{ minRows: 5, maxRows: 20 }"-->
                <!--                    ></el-input>-->
                <!--                  </el-col>-->
                <!--                </el-form-item>-->
                <!--                <el-form-item-->
                <!--                  label="科研项目经历:"-->
                <!--                  prop="education.scientificOrientation"-->
                <!--                >-->
                <!--                  <el-col :lg="20" :sm="16" :xs="16">-->
                <!--                    <el-input-->
                <!--                      v-model="form.education.scientificOrientation"-->
                <!--                      type="textarea"-->
                <!--                      readonly-->
                <!--                      :rows="5"-->
                <!--                      :autosize="{ minRows: 5, maxRows: 20 }"-->
                <!--                    ></el-input>-->
                <!--                  </el-col>-->
                <!--                </el-form-item>-->
                <el-form-item
                  label="代表性学术成果(文章专利):"
                  prop="education.achievement"
                >
                  <el-col :lg="20" :sm="16" :xs="16">
                    <el-input
                      v-model="form.education.achievement"
                      type="textarea"
                      readonly
                      :rows="5"
                      :autosize="{ minRows: 5, maxRows: 20 }"
                    ></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item label="高校获奖情况:" prop="education.prizeCase">
                  <el-col :lg="20" :sm="16" :xs="16">
                    <el-input
                      v-model="form.education.prizeCase"
                      type="textarea"
                      readonly
                      :rows="5"
                      :autosize="{ minRows: 5, maxRows: 20 }"
                    ></el-input>
                  </el-col>
                </el-form-item>
<!--                <el-row>-->
<!--                  <el-col :lg="12" :sm="24" :xs="24">-->
<!--                    <el-form-item-->
<!--                      label="技能大赛获奖类别:"-->
<!--                      prop="education.winAwardType"-->
<!--                    >-->
<!--                      <span>{{ form.education.winAwardType }}</span>-->
<!--                    </el-form-item>-->
<!--                  </el-col>-->
<!--                </el-row>-->
<!--                <el-form-item-->
<!--                  label="技能大赛获奖等级:"-->
<!--                  prop="education.winAwardLevel"-->
<!--                >-->
<!--                  <el-col :lg="20" :sm="16" :xs="16">-->
<!--                    <el-input-->
<!--                      v-model="form.education.winAwardLevel"-->
<!--                      type="textarea"-->
<!--                      readonly-->
<!--                      :rows="5"-->
<!--                      :autosize="{ minRows: 5, maxRows: 20 }"-->
<!--                    ></el-input>-->
<!--                  </el-col>-->
<!--                </el-form-item>-->
<!--                <el-form-item-->
<!--                  label="技能大赛获奖名称:"-->
<!--                  prop="education.winAwardName"-->
<!--                >-->
<!--                  <el-col :lg="20" :sm="16" :xs="16">-->
<!--                    <el-input-->
<!--                      v-model="form.education.winAwardName"-->
<!--                      type="textarea"-->
<!--                      readonly-->
<!--                      :rows="5"-->
<!--                      :autosize="{ minRows: 5, maxRows: 20 }"-->
<!--                    ></el-input>-->
<!--                  </el-col>-->
<!--                </el-form-item>-->
<!--                <el-form-item-->
<!--                  label="技能大赛获奖名次:"-->
<!--                  prop="education.winAwardRank"-->
<!--                >-->
<!--                  <el-col :lg="20" :sm="16" :xs="16">-->
<!--                    <el-input-->
<!--                      v-model="form.education.winAwardRank"-->
<!--                      type="textarea"-->
<!--                      readonly-->
<!--                      :rows="5"-->
<!--                      :autosize="{ minRows: 5, maxRows: 20 }"-->
<!--                    ></el-input>-->
<!--                  </el-col>-->
<!--                </el-form-item>-->
                <el-form-item
                  label="学生工作社团组织:"
                  prop="education.massCase"
                >
                  <el-col :lg="20" :sm="16" :xs="16">
                    <el-input
                      v-model="form.education.massCase"
                      type="textarea"
                      readonly
                      :rows="5"
                      :autosize="{ minRows: 5, maxRows: 20 }"
                    ></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item label="自我评价及其他说明:" prop="remark">
                  <el-col :lg="20" :sm="16" :xs="16">
                    <el-input
                      v-model="form.remark"
                      type="textarea"
                      readonly
                      :rows="5"
                      :autosize="{ minRows: 5, maxRows: 20 }"
                    ></el-input>
                  </el-col>
                </el-form-item>
              </div>
              <!--技能类-->
              <div v-if="isTechnique">
                <div style="font-weight: bold; margin-bottom: 10px">
                  <span><b>学习阶段：</b> </span>
                </div>
                <el-card
                  v-for="row in form.experienceList"
                  :key="row.phase"
                  style=""
                >
                  <div slot="header">
                    <span>{{ row.phase }}</span>
                  </div>
                  <el-row>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="开始日期:" prop="startDate" required>
                        <span>{{ row.startDate }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="结束日期:" prop="endDate" required>
                        <span>{{ row.endDate }}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="毕业单位:" prop="university" required>
                        <span>{{ row.university }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="学院/系:" prop="institutions">
                        <span>{{ row.institutions }}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="一级学科:" prop="studyField" required>
                        <span>{{ row.studyField }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="毕业专业:" prop="majorCourse" required>
                        <span>{{ row.majorCourse }}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="专业总人数:" prop="totalNumber">
                        <span>{{ row.totalNumber }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="综合排名:" prop="rankNum">
                        <span>{{ row.rankNum }}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="学习形式:" prop="learningShape" required>
                        <span>{{ row.learningShape }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="备注:" prop="remark">
                        <span>{{ row.remark }}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-card>
                <div
                  v-if="form.degreeList.length > 0"
                  style="font-weight: bold; margin-bottom: 10px"
                >
                  <span><b>学位情况：</b> </span>
                </div>
                <el-card
                  v-for="row in form.degreeList"
                  :key="row.degreeName"
                  style=""
                >
                  <div slot="header">
                    <span>{{ row.degreeName }}</span>
                  </div>
                  <el-row>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="开始日期:" prop="startDate" required>
                        <span>{{ row.startDate.substring(0, 10) }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="结束日期:" prop="endDate" required>
                        <span>{{ row.endDate.substring(0, 10) }}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="学位授予单位:" prop="degreeDept" required>
                        <span>{{ row.degreeDept }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="学习形式:" prop="learningFormat" required>
                        <span>{{ row.learningFormat }}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="获学位学科:" prop="degreeScience" required>
                        <span>{{ row.degreeScience }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="获学位专业:" prop="degreeStudyField" required>
                        <span>{{ row.degreeStudyField }}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-card>
                <div style="margin-bottom: 10px">
                  <el-row>
                    <el-col :span="20"
                    ><span class="spanTitle">语言语种:</span>
                    </el-col>
                  </el-row>
                </div>
                <el-card>
                  <div style="overflow: auto; height: 240px">
                    <zr-table
                        ref="familyTable"
                        height-fixed
                        class="user-box"
                        selection-type="single"
                        :data="form.languageInfoList"
                        :columns="languageInfoColumns"
                        table-height="200px"
                        stripe
                    >
                      <template v-slot:languageClass="{ row }">
                        <span>{{row['languageClass']}}</span>
                      </template>
                      <template v-slot:languageCertificate="{ row }">
                        <span>{{row['languageCertificate']}}</span>
                      </template>
                      <template v-slot:languageScore="{ row }">
                        <span>{{row['languageScore']}}</span>
                      </template>
                    </zr-table>
                  </div>
                </el-card>
                <div style="margin-bottom: 10px">
                  <el-row>
                    <el-col :span="20"
                      ><span class="spanTitle">实习经历:</span>
                    </el-col>
                  </el-row>
                </div>
                <el-card>
                  <div style="overflow: auto; height: 240px">
                    <zr-table
                      ref="familyTable"
                      height-fixed
                      class="user-box"
                      selection-type="single"
                      :data="form.parcticeLiveList"
                      :columns="parcticeLiveColumns"
                      table-height="200px"
                      stripe
                    >
                      <template v-slot:startLiveTime="{ row }">
                        <el-date-picker
                          v-model="row['startLiveTime']"
                          type="date"
                          placeholder="选择开始日期"
                          readonly
                        >
                        </el-date-picker>
                      </template>
                      <template v-slot:endLiveTime="{ row }">
                        <el-date-picker
                          v-model="row['endLiveTime']"
                          type="date"
                          placeholder="选择结束日期"
                          readonly
                        >
                        </el-date-picker>
                      </template>
                      <template v-slot:companyName="{ row }">
                        <span>{{row['companyName']}}</span>
                      </template>
                      <template v-slot:location="{ row }">
                        <span>{{row['location']}}</span>
                      </template>
                      <template v-slot:workDeptName="{ row }">
                        <span>{{row['workDeptName']}}</span>
                      </template>
                      <template v-slot:workPostName="{ row }">
<!--                        <el-input-->
<!--                          v-model="row['workPostName']"-->
<!--                          size="mini"-->
<!--                          readonly-->
<!--                          maxlength="500"-->
<!--                        ></el-input>-->
                        <span>{{row['workPostName']}}</span>
                      </template>
                      <template v-slot:achievement="{ row }">
<!--                        <el-input-->
<!--                          v-model="row['achievement']"-->
<!--                          size="mini"-->
<!--                          readonly-->
<!--                          maxlength="500"-->
<!--                          clearable-->
<!--                        ></el-input>-->
                        <span>{{row['companyName']}}</span>
                      </template>
                    </zr-table>
                  </div>
                </el-card>
                <div style="margin-bottom: 10px">
                  <el-row>
                    <el-col :span="20"
                      ><span class="spanTitle">工作经历:</span>
                    </el-col>
                  </el-row>
                </div>
                <el-card>
                  <div style="overflow: auto; height: 240px">
                    <zr-table
                      ref="familyTable"
                      height-fixed
                      class="user-box"
                      selection-type="single"
                      :data="form.workLiveList"
                      :columns="workLiveColumns"
                      table-height="200px"
                      stripe
                    >
                      <template v-slot:startLiveTime="{ row }">
                        <el-date-picker
                          v-model="row['startLiveTime']"
                          type="date"
                          placeholder="选择开始日期"
                          readonly
                        >
                        </el-date-picker>
                      </template>
                      <template v-slot:endLiveTime="{ row }">
                        <el-date-picker
                          v-model="row['endLiveTime']"
                          type="date"
                          placeholder="选择结束日期"
                          readonly
                        >
                        </el-date-picker>
                      </template>
                      <template v-slot:companyName="{ row }">
<!--                        <el-input-->
<!--                          v-model="row['companyName']"-->
<!--                          size="mini"-->
<!--                          maxlength="32"-->
<!--                          readonly-->
<!--                        ></el-input>-->
                        <span>{{row['companyName']}}</span>
                      </template>
                      <template v-slot:location="{ row }">
<!--                        <el-input-->
<!--                          v-model="row['location']"-->
<!--                          size="mini"-->
<!--                          readonly-->
<!--                          maxlength="32"-->
<!--                        ></el-input>-->
                        <span>{{row['location']}}</span>
                      </template>
                      <template v-slot:workDeptName="{ row }">
<!--                        <el-input-->
<!--                          v-model="row['workDeptName']"-->
<!--                          size="mini"-->
<!--                          readonly-->
<!--                          maxlength="500"-->
<!--                        ></el-input>-->
                        <span>{{row['workDeptName']}}</span>
                      </template>
                      <template v-slot:workPostName="{ row }">
<!--                        <el-input-->
<!--                          v-model="row['workPostName']"-->
<!--                          size="mini"-->
<!--                          readonly-->
<!--                          maxlength="500"-->
<!--                        ></el-input>-->
                        <span>{{row['workPostName']}}</span>
                      </template>
                      <template v-slot:achievement="{ row }">
<!--                        <el-input-->
<!--                          v-model="row['achievement']"-->
<!--                          size="mini"-->
<!--                          maxlength="500"-->
<!--                          readonly-->
<!--                          clearable-->
<!--                        ></el-input>-->
                        <span>{{row['achievement']}}</span>
                      </template>
                    </zr-table>
                  </div>
                </el-card>
                <div style="margin-bottom: 10px">
                  <el-row>
                    <el-col :span="20"
                      ><span class="spanTitle">科研项目经历:</span>
                    </el-col>
                  </el-row>
                </div>
                <el-card>
                  <div style="overflow: auto; height: 240px">
                    <zr-table
                      ref="familyTable"
                      height-fixed
                      class="user-box"
                      selection-type="single"
                      :data="form.projectLiveList"
                      :columns="projectLiveColumns"
                      table-height="200px"
                      stripe
                    >
                      <template v-slot:startLiveTime="{ row }">
                        <el-date-picker
                          v-model="row['startLiveTime']"
                          type="date"
                          readonly
                          placeholder="选择开始日期"
                        >
                        </el-date-picker>
                      </template>
                      <template v-slot:endLiveTime="{ row }">
                        <el-date-picker
                          v-model="row['endLiveTime']"
                          type="date"
                          readonly
                          placeholder="选择结束日期"
                        >
                        </el-date-picker>
                      </template>
                      <template v-slot:projectName="{ row }">
<!--                        <el-input-->
<!--                          v-model="row['projectName']"-->
<!--                          size="mini"-->
<!--                          readonly-->
<!--                          maxlength="32"-->
<!--                        ></el-input>-->
                        <span>{{row['projectName']}}</span>
                      </template>
                      <template v-slot:projectRole="{ row }">
<!--                        <el-input-->
<!--                          v-model="row['projectRole']"-->
<!--                          size="mini"-->
<!--                          readonly-->
<!--                          maxlength="32"-->
<!--                        ></el-input>-->
                        <span>{{row['projectRole']}}</span>
                      </template>
                      <template v-slot:companyName="{ row }">
<!--                        <el-input-->
<!--                          v-model="row['companyName']"-->
<!--                          size="mini"-->
<!--                          readonly-->
<!--                          maxlength="500"-->
<!--                        ></el-input>-->
                        <span>{{row['companyName']}}</span>
                      </template>
                      <template v-slot:achievement="{ row }">
<!--                        <el-input-->
<!--                          v-model="row['achievement']"-->
<!--                          size="mini"-->
<!--                          clearable-->
<!--                          readonly-->
<!--                          maxlength="500"-->
<!--                        ></el-input>-->
                        <span>{{row['achievement']}}</span>
                      </template>
                    </zr-table>
                  </div>
                </el-card>
                <!--                <el-row>-->
                <!--                  <el-col span="12">-->
                <!--                    <el-form-item label="大专毕业日期:" prop="high">-->
                <!--                      <span>{{ form.education.graduateDate }}</span>-->
                <!--                    </el-form-item>-->
                <!--                  </el-col>-->
                <!--                  <el-col span="12">-->
                <!--                    <el-form-item-->
                <!--                      label="是否通过高等学校英语应用能力考试:"-->
                <!--                      prop="weight"-->
                <!--                    >-->
                <!--                      <span>{{ form.education.isPassEngUseExam }}</span>-->
                <!--                    </el-form-item>-->
                <!--                  </el-col>-->
                <!--                </el-row>-->
                <!--                <el-form-item-->
                <!--                  label="国家职业资格:"-->
                <!--                  prop="education.professionLevel"-->
                <!--                >-->
                <!--                  <el-col :span="16"-->
                <!--                    ><el-input-->
                <!--                      v-model="form.education.professionLevel"-->
                <!--                      maxlength="20"-->
                <!--                      placeholder="国家职业资格等级"-->
                <!--                      clearable-->
                <!--                    ></el-input-->
                <!--                  ></el-col>-->
                <!--                </el-form-item>-->
                <el-row>
                  <el-col :lg="12" :sm="24" :xs="24">
                    <el-form-item
                        label="是否应届生:"
                        prop="education.freshGraduate"
                        required
                    >
                      <span>{{ form.education.freshGraduate }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :lg="12" :sm="24" :xs="24">
                    <el-form-item
                        label="计算机等级:"
                        prop="education.programLevel"
                    >
                      <span>{{ form.education.programLevel }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
<!--                <el-form-item label="计算机等级:" prop="education.programLevel">-->
<!--                  <el-col :span="16"-->
<!--                    ><el-input-->
<!--                      v-model="form.education.programLevel"-->
<!--                      maxlength="20"-->
<!--                      placeholder="计算机/程序员等级（注明全国/地区）"-->
<!--                      clearable-->
<!--                      readonly-->
<!--                    ></el-input-->
<!--                  ></el-col>-->
<!--                </el-form-item>-->
                <el-form-item label="主干课程:" prop="education.course" required>
                  <el-col :lg="20" :sm="16" :xs="16">
                    <el-input
                      v-model="form.education.course"
                      type="textarea"
                      readonly
                      :rows="5"
                      :autosize="{ minRows: 5, maxRows: 20 }"
                    ></el-input>
                  </el-col>
                </el-form-item>
                <!--                <el-form-item label="实习经历:" prop="education.internship">-->
                <!--                  <el-col :lg="20" :sm="16" :xs="16">-->
                <!--                    <el-input-->
                <!--                      v-model="form.education.internship"-->
                <!--                      type="textarea"-->
                <!--                      readonly-->
                <!--                      :rows="5"-->
                <!--                      :autosize="{ minRows: 5, maxRows: 20 }"-->
                <!--                    ></el-input>-->
                <!--                  </el-col>-->
                <!--                </el-form-item>-->
                <el-form-item label="高校获奖情况:" prop="education.prizeCase">
                  <el-col :lg="20" :sm="16" :xs="16">
                    <el-input
                      v-model="form.education.prizeCase"
                      type="textarea"
                      readonly
                      :rows="5"
                      :autosize="{ minRows: 5, maxRows: 20 }"
                    ></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item
                  label="学生工作社团组织:"
                  prop="education.massCase"
                >
                  <el-col :lg="20" :sm="16" :xs="16">
                    <el-input
                      v-model="form.education.massCase"
                      type="textarea"
                      readonly
                      :rows="5"
                      :autosize="{ minRows: 5, maxRows: 20 }"
                    ></el-input>
                  </el-col>
                </el-form-item>
                <!--                <el-form-item-->
                <!--                  label="技能比赛获奖情况:"-->
                <!--                  prop="education.skillGameInfo"-->
                <!--                >-->
                <!--                  <el-col :lg="20" :sm="16" :xs="16">-->
                <!--                    <el-input-->
                <!--                      v-model="form.education.skillGameInfo"-->
                <!--                      type="textarea"-->
                <!--                      readonly-->
                <!--                      :rows="5"-->
                <!--                      :autosize="{ minRows: 5, maxRows: 20 }"-->
                <!--                    ></el-input>-->
                <!--                  </el-col>-->
                <!--                </el-form-item>-->
                <!--                <el-form-item-->
                <!--                  label="技能比赛实操情况说明:"-->
                <!--                  prop="education.actualOperateInfo"-->
                <!--                >-->
                <!--                  <el-col :lg="20" :sm="16" :xs="16">-->
                <!--                    <el-input-->
                <!--                      v-model="form.education.actualOperateInfo"-->
                <!--                      type="textarea"-->
                <!--                      readonly-->
                <!--                      :rows="5"-->
                <!--                      :autosize="{ minRows: 5, maxRows: 20 }"-->
                <!--                    ></el-input>-->
                <!--                  </el-col>-->
                <!--                </el-form-item>-->
                <el-row>
                  <el-col :lg="12" :sm="24" :xs="24">
                    <el-form-item
                      label="技能大赛获奖类别:"
                      prop="education.winAwardType"
                    >
                      <span>{{ form.education.winAwardType }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item label="技能大赛获奖等级:" prop="education.winAwardLevel">
                  <el-col :lg="20" :sm="16" :xs="16">
                    <el-input
                      v-model="form.education.winAwardLevel"
                      type="textarea"
                      readonly
                      :rows="5"
                      :autosize="{ minRows: 5, maxRows: 20 }"
                    ></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item label="技能大赛获奖名称:" prop="education.winAwardName">
                  <el-col :lg="20" :sm="16" :xs="16">
                    <el-input
                      v-model="form.education.winAwardName"
                      type="textarea"
                      readonly
                      :rows="5"
                      :autosize="{ minRows: 5, maxRows: 20 }"
                    ></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item label="技能大赛获奖名次:" prop="education.winAwardRank">
                  <el-col :lg="20" :sm="16" :xs="16">
                    <el-input
                        v-model="form.education.winAwardRank"
                        type="textarea"
                        readonly
                        :rows="5"
                        :autosize="{ minRows: 5, maxRows: 20 }"
                    ></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item label="自我评价及其他说明:" prop="remark">
                  <el-col :lg="20" :sm="16" :xs="16">
                    <el-input
                      v-model="form.remark"
                      type="textarea"
                      readonly
                      :rows="5"
                      :autosize="{ minRows: 5, maxRows: 20 }"
                    ></el-input>
                  </el-col>
                </el-form-item>
              </div>
             <el-card  v-if="isPost || isView">
               <span style="font-weight: bold;font-size: large"><font style="color: red">*</font>个人简历附件栏</span>
               <el-upload
                   ref="upload"
                   title="个人简历附件列表"
                   :action="uploadAction"
                   :headers="headers"
                   :on-preview="handleDownload"
                   :file-list="form.fileList1"
                   disabled
               >
               </el-upload>
             </el-card>
              <el-card v-if="isPost || isView">
                <span style="font-weight: bold;font-size: large">其他附件栏</span>
              <el-upload
                ref="upload"
                title="其他附件列表"
                :action="uploadAction"
                :headers="headers"
                :on-preview="handleDownload"
                :file-list="form.fileList"
                disabled
              >
              </el-upload>
              </el-card>
              <el-divider />
            </div>
          </el-form>
          <slot name="footBtn" :form="form">
            <el-button
              v-if="isView && loginUser && !collected && curRole != 'hr'"
              icon="el-icon-star-on"
              type="primary"
              style="float: right"
              @click="doCollect"
              >收藏</el-button
            >
            <el-button
              v-if="isView && loginUser && collected && curRole != 'hr'"
              icon="el-icon-star-off"
              type="primary"
              style="float: right"
              @click="doDisCollect"
              >取消收藏</el-button
            >
            <el-button
              v-if="
                isView && loginUser && !unSuit && curRole != 'hr' && !isOpen
              "
              icon="el-icon-remove-outline"
              type="warning"
              style="float: right"
              @click="doUnSuit"
              >不合适</el-button
            >
            <el-popover
              v-if="isView && loginUser && !unSuit && curRole != 'hr' && isOpen"
              v-model="popVisible"
              placement="top"
              width="400"
              trigger="click"
            >
              <div>
                <el-row>
                  <el-input
                    v-model="noFitMessage"
                    placeholder="可添加额外信息到邮件正文，不填则为默认统一格式"
                    maxlength="50"
                    clearable
                  ></el-input>
                </el-row>
                <el-row style="margin-top: 10px">
                  <el-button
                    icon="el-icon-circle-check"
                    type="success"
                    style="float: right"
                    @click="doUnSuit"
                    >确定</el-button
                  >
                  <el-button
                    icon="el-icon-circle-close"
                    style="float: right"
                    @click="popVisible = false"
                    >取消</el-button
                  >
                </el-row>
              </div>
              <el-button
                slot="reference"
                icon="el-icon-remove-outline"
                type="warning"
                style="float: right"
                >不合适</el-button
              >
            </el-popover>
            <el-button
              v-if="isView && loginUser && unSuit && curRole != 'hr'"
              icon="el-icon-circle-plus-outline"
              type="warning"
              style="float: right"
              @click="doSuit"
              >合适</el-button
            >
            <el-button
              icon="el-icon-view"
              style="float: right"
              type="info"
              plain
              @click="otherPost"
              >其他岗位投递信息</el-button
            >
            <el-button
              icon="el-icon-back"
              style="float: right"
              type="success"
              plain
              @click="back"
              >返回</el-button
            >
          </slot>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getBasicData } from "@/api/job/postInfo";
import {
  getAllResumeInfoByPositionIdAndUserPhone,
  getResumeInfoViewById as getResumeInfoById,
  getResumeInfoByUserPhone,
  saveResumeInfo,
  unSuitResume,
  suitResume,
  collectResume,
  unCollectResume,
} from "@/api/recruit/user/resume";
import { downloadFile } from "@/utils/downFile";
import isMobile from "@/utils/device";
import { mapGetters } from "vuex";
import settingHelp from "@/config/localSetting";
import { getEmailData } from "@api/recruit/hr/resumeManagement";
import { messageDuration } from "../../../config/settings";
import store from "@/store";
import { searchBasicData } from "@api/framework/basicData/dataDictType";
const config = settingHelp.getConfig();
const { remoteURL, developer } = config;
const token1 = localStorage.getItem("token");
const token2 = store.getters["user/accessToken"];
const token = token2 ? token2 : token1;

export default {
  name: "PostInfoEdit",
  data() {
    return {
      studyFiled: {},
      headers: { Authorization: token },
      loading: true, // 加载中
      isMb: false, // 是否是移动设备
      popVisible: false,
      noFitMessage: "", // 不合适时要发送邮件的信息
      isOpen: false, // 12所要求功能是否开启
      // form: {
      //   name: "",
      //   sex: "",
      //   fileList: [], // 附件列表
      //   experienceList: [], // 教育经历表格行默认数据
      //   education: {}, // 教育经历
      // },
      form: {
        name: "",
        sex: "",
        fileList: [], // 附件列表
        experienceList: [], // 教育经历表格行默认数据
        degreeList: [], //学位表格行默认数据
        education: {}, // 教育经历
        familyInfo: [], // 家庭成员情况
        parcticeLiveList: [], //实习经历
        workLiveList: [], //工作经历
        projectLiveList: [], //项目经历
        languageInfoList: [], //语言情况
        topDegree: "", // 最高教育经历
        topDegreeName: "", //最高学位
      },
      pictureUploadAction: "", // 照片上传地址
      uploadAction: "", // 附件上传地址,附件上传前需要先投递简历
      nationArray: [],
      imageUrl: "",
      isView: false, // 管理员查看模式
      isRequired: true, //学生编辑模式
      loginUser: {}, // 登录人员信息
      isTechnique: false, // 技能类
      isProfessionTech: false, // 专技类
      isPost: false, // 是否是投递页面
      unSuit: false, // 是否不合适
      collected: false, // 是否已经收藏
      positionId: "", // 投递的职位id
      postSendId: "", // 简历与投递职位的关联表id
      selectedRow: null, // 选择的行
      basicPoliticallyState: [], //政治面貌数据字典
      basicSex: [
        { name: "男", code: "male" },
        { name: "女", code: "female" },
      ],
      familyColumns: [
        {
          name: "与本人关系",
          code: "relationship",
          needDrawCell: true,
          width: "110",
        },
        { name: "姓名", code: "name", needDrawCell: true },
        { name: "性别", code: "sex", needDrawCell: true },
        {
          name: "出生日期",
          code: "birthDay",
          needDrawCell: true,
          width: "150",
        },
        { name: "民族", code: "nation", needDrawCell: true, width: "120" },
        {
          name: "政治面貌",
          code: "politicallyState",
          needDrawCell: true,
          width: "150",
        },
        {
          name: "单位名称",
          code: "deptAndHeadship",
          needDrawCell: true,
          width: "100",
        },
        {
          name: "职务",
          code: "workInfo",
          needDrawCell: true,
          width: "100",
        }
      ],
      languageInfoColumns: [
        { name: "语言语种", code: "languageClass", needDrawCell: true },
        {
          name: "证书",
          code: "languageCertificate",
          needDrawCell: true,
        },
        { name: "证书成绩", code: "languageScore", needDrawCell: true },
      ],
      parcticeLiveColumns: [
        { name: "开始时间", code: "startLiveTime", needDrawCell: true },
        { name: "结束时间", code: "endLiveTime", needDrawCell: true },
        { name: "单位名称", code: "companyName", needDrawCell: true },
        { name: "地点", code: "location", needDrawCell: true },
        { name: "任职部门", code: "workDeptName", needDrawCell: true },
        { name: "任职职位", code: "workPostName", needDrawCell: true },
        {
          name: "主要职责与业绩",
          code: "achievement",
          needDrawCell: true,
          width: "120",
        },
      ],
      workLiveColumns: [
        { name: "开始时间", code: "startLiveTime", needDrawCell: true },
        { name: "结束时间", code: "endLiveTime", needDrawCell: true },
        { name: "单位名称", code: "companyName", needDrawCell: true },
        { name: "地点", code: "location", needDrawCell: true },
        { name: "任职部门", code: "workDeptName", needDrawCell: true },
        { name: "任职职位", code: "workPostName", needDrawCell: true },
        {
          name: "主要职责与业绩",
          code: "achievement",
          needDrawCell: true,
          width: "120",
        },
      ],
      projectLiveColumns: [
        { name: "开始时间", code: "startLiveTime", needDrawCell: true },
        { name: "结束时间", code: "endLiveTime", needDrawCell: true },
        { name: "项目名称", code: "projectName", needDrawCell: true },
        { name: "角色", code: "projectRole", needDrawCell: true },
        { name: "单位名称", code: "companyName", needDrawCell: true },
        {
          name: "主要职责与业绩",
          code: "achievement",
          needDrawCell: true,
          width: "120",
        },
      ],
      columns: [
        {
          code: "phase",
          name: "阶段",
          width: "100",
        },
        {
          code: "startDate",
          name: "开始时间",
          needDrawCell: true,
          width: "120",
        },
        {
          code: "endDate",
          name: "结束时间",
          needDrawCell: true,
          width: "120",
        },
        {
          code: "university",
          name: "学校",
          needDrawCell: true,
          width: "160",
        },
        {
          code: "institutions",
          name: "学院/系",
          needDrawCell: true,
          width: "160",
        },
        {
          code: "studyField",
          name: "专业",
          needDrawCell: true,
          width: "160",
        },
        {
          code: "rankNum",
          name: "综合排名",
          width: "80",
          needDrawCell: true,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      userPhone: "user/userPhone",
      userName: "user/userName",
      userCode: "user/userCode",
      curRole: "user/curRole",
      deptCode: "user/deptCode",
    }),
  },
  async created() {
    // 判断是否是移动设备
    this.isMb = await isMobile();
    // 路由参数 判断页面状态
    if (this.$route.query.isView) {
      this.isView = true;
      this.isRequired = false;
    }
    // 民族数据字典
    await this.getNationArray();
    //政治面貌数据字典
    await this.getPoliticallyArray();
    // 查询简历信息
    await this.getResumeInfo();
    // 查询默认邮件发送信息
    await this.initNoFitMessage();
    // 学历列表判断
    if (this.isProfessionTech && !this.form.experienceList) {
      // 专技类
      this.form.experienceList = [{ phase: "本科", resumeId: this.form.id }];
    }
    if (this.isTechnique && !this.form.experienceList) {
      // 技能类
      this.form.experienceList = [{ phase: "大专", resumeId: this.form.id }];
      this.columns = [
        {
          code: "phase",
          name: "阶段",
          width: "60",
        },
        {
          code: "startDate",
          name: "开始时间",
          needDrawCell: true,
          width: "120",
        },
        {
          code: "endDate",
          name: "结束时间",
          needDrawCell: true,
          width: "120",
        },
        {
          code: "university",
          name: "学校",
          needDrawCell: true,
          width: "155",
        },
        {
          code: "institutions",
          name: "学院/系",
          needDrawCell: true,
          width: "155",
        },
        {
          code: "studyField",
          name: "专业",
          needDrawCell: true,
          width: "155",
        },
        {
          code: "remark",
          name: "备注",
          needDrawCell: true,
          width: "150",
        },
      ];
    }
  },
  async beforeMount() {},
  mounted() {
    if (this.deptCode) {
      // 查询是否开启邮件功能
      getEmailData({ deptCode: this.deptCode }).then((res) => {
        if (res.success) {
          if (
            res.data &&
            res.data.email &&
            res.data.key &&
            res.data.address &&
            res.data.isOpen == "true"
          ) {
            this.isOpen = true;
          }
        } else {
          this.$message({
            showClose: true,
            message: "查询邮件功能是否开启：接口访问失败!" + res.message,
            type: "error",
          });
        }
      });
    }
  },
  methods: {
    renderData(data, dic) {
      let cuitem = dic.find((item) => item.code === data);
      return cuitem?.name;
    },
    renderTimeData(data, dic) {
      let cuitem = dic.find((item) => item.code === data);
      return cuitem?.name;
    },
    // 民族
    async getNationArray() {
      let res = await getBasicData({ typeCode: "nation" });
      if (res.success) {
        this.nationArray = res.data;
      } else {
        this.$message.error({ showClose: true, message: res.message });
      }
    },
    //政治面貌 1005
    async getPoliticallyArray() {
      let res = await getBasicData({ typeCode: "politicallyState" });
      if (res.success) {
        this.basicPoliticallyState = res.data;
      } else {
        this.$message.error(res.message);
      }
    },
    birthdayDateChange(value) {
      this.form.birthday = value;
    },
    graduateDateChange(value) {
      this.form.education.graduateDate = value;
    },
    async initNoFitMessage() {
      // const res = await searchBasicData({ typeCode: "noFitMessage" });
      // if (res.success) {
      //   this.noFitMessage = res.data[0].remark;
      // } else {
      //   this.$message.error({ showClose: true, message: res.message });
      // }
    },
    // 查询简历信息
    async getResumeInfo() {
      // 管理员查看简历---------------------------------------
      if (this.$route.query.postSendId) {
        this.isView = true;
        this.isRequired = false;
        // this.isPost = true;
        let res = await getResumeInfoById({
          postSendId: this.$route.query.postSendId,
        });
        if (res.success) {
          // 回填状态参数
          this.postSendId = res.data.postSendId;
          this.unSuit = res.data.unSuit;
          this.collected = res.data.collected;
          // 回填数据
          this.dataToForm(res.data);
          this.loading = false;
        } else {
          this.$message.error({ showClose: true, message: res.message });
          setTimeout(() => {
            this.loading = false;
          }, 5000);
        }
      }
    },
    // 表单数据回填
    dataToForm(data) {
      // 性别
      let sexTypeArray = [
        { name: "男", code: "male" },
        { name: "女", code: "female" },
      ];
      for (let i in sexTypeArray) {
        if (sexTypeArray[i].code == data.formData.sex) {
          data.formData.sex = sexTypeArray[i].name;
          break;
        }
      }
      // 婚否
      // let marriedTypeArray = [
      //   { name: "已婚", code: 1 },
      //   { name: "未婚", code: 0 },
      //   { name: "未婚", code: null },
      // ];
      let marriedTypeArray = [
        { name: "离婚", code: 6 },
        { name: "丧偶", code: 5 },
        { name: "复婚", code: 4 },
        { name: "再婚", code: 3 },
        { name: "初婚", code: 2 },
        { name: "已婚", code: 1 },
        { name: "未婚", code: 0 },
      ];
      for (let i in marriedTypeArray) {
        if (marriedTypeArray[i].code == data.formData.married) {
          data.formData.married = marriedTypeArray[i].name;
          break;
        }
      }
      // 民族
      for (let i in this.nationArray) {
        if (this.nationArray[i].code == data.formData.nation) {
          data.formData.nation = this.nationArray[i].name;
          break;
        }
      }
      // 英语情况
      let hasEngLevelArray = [
        { name: "英语四级", code: "CET4" },
        { name: "英语六级", code: "CET6" },
        { name: "其他", code: "TEM4" },
      ];
      for (let i in hasEngLevelArray) {
        if (hasEngLevelArray[i].code == data.formData.education.engLevel) {
          data.formData.education.engLevel = hasEngLevelArray[i].name;
          break;
        }
      }
      // 海外情况
      let hasBroadExpArray = [
        { name: "是", code: 1 },
        { name: "否", code: 0 },
        { name: "否", code: null },
      ];
      for (let i in hasBroadExpArray) {
        if (hasBroadExpArray[i].code == data.formData.hasBroadExp) {
          data.formData.hasBroadExp = hasBroadExpArray[i].name;
          break;
        }
      }
      // 海外情况
      let isPassEngUseExamArray = [
        { name: "通过", code: 1 },
        { name: "不通过", code: 0 },
        { name: "不通过", code: null },
      ];
      for (let i in isPassEngUseExamArray) {
        if (
          isPassEngUseExamArray[i].code ==
          data.formData.education.isPassEngUseExam
        ) {
          data.formData.education.isPassEngUseExam =
            isPassEngUseExamArray[i].name;
          break;
        }
      }
      // 政治面貌
      let politicallyStateArray = [
        { name: "群众", code: "concourse" },
        { name: "中共党员", code: "partyMember" },
        { name: "中共预备党员", code: "中共预备党员" },
        { name: "共青团员", code: "共青团员" },
        { name: "民革会员", code: "民革会员" },
        { name: "民盟盟员", code: "民盟盟员" },
        { name: "民建会员", code: "民建会员" },
        { name: "民进会员", code: "民进会员" },
        { name: "农工党党员", code: "农工党党员" },
        { name: "致公党党员", code: "致公党党员" },
        { name: "九三学社社员", code: "九三学社社员" },
        { name: "台盟盟员", code: "台盟盟员" },
        { name: "无党派民主人士", code: "无党派民主人士" },
        { name: "其他", code: "其他" },
      ];
      for (let i in politicallyStateArray) {
        if (politicallyStateArray[i].code == data.formData.politicallyState) {
          data.formData.politicallyState = politicallyStateArray[i].name;
          break;
        }
      }
      // 统招一本
      let isUnifyArray = [
        { name: "是", code: 1 },
        { name: "否", code: 0 },
        { name: "否", code: null },
      ];
      for (let i in isPassEngUseExamArray) {
        if (isUnifyArray[i].code == data.formData.education.isUnify) {
          data.formData.education.isUnify = isUnifyArray[i].name;
          break;
        }
      }
      this.pictureUploadAction =
        remoteURL + "/comm/file/uploadPicture?resumeId=" + data.formData.id; // 照片上传加上url简历id
      // 是否统招一本
      if (data.formData.education && data.formData.education.isUnify == null)
        data.formData.education.isUnify = 0;
      // 时间格式处理
      if (data.formData.birthday && data.formData.birthday.length > 10) {
        data.formData.birthday = data.formData.birthday.substring(0, 10);
      }
      if (
        data.formData.education.graduateDate &&
        data.formData.education.graduateDate.length > 10
      ) {
        data.formData.education.graduateDate = data.formData.education.graduateDate.substring(
          0,
          10
        );
      }
      if (data.postSendId) this.postSendId = data.postSendId;
      if (data.isProfessionTech) this.isProfessionTech = data.isProfessionTech;
      if (data.isTechnique) this.isTechnique = data.isTechnique;
      if (data.formData.employeePic)
        this.imageUrl =
          remoteURL + "/comm/file/downloadPicture?resumeId=" + data.formData.id; // 照片加载url简历id
      if (!data.formData.education) data.formData.education = {};
      if (!data.formData.education) data.formData.education = {};
      this.form = data.formData;
      if (
        data.formData.experienceList &&
        data.formData.experienceList.length &&
        data.formData.experienceList.length > 0
      ) {
        this.form.topDegree =
          data.formData.experienceList[
            data.formData.experienceList.length - 1
          ].phase;
        this.form.topUniversity =
          data.formData.experienceList[
            data.formData.experienceList.length - 1
          ].university;
        for (let i in data.formData.experienceList) {
          if (
            data.formData.experienceList[i].startDate &&
            data.formData.experienceList[i].startDate.length > 10
          )
            data.formData.experienceList[
              i
            ].startDate = data.formData.experienceList[i].startDate.substring(
              0,
              10
            );
          if (
            data.formData.experienceList[i].endDate &&
            data.formData.experienceList[i].endDate.length > 10
          )
            data.formData.experienceList[
              i
            ].endDate = data.formData.experienceList[i].endDate.substring(
              0,
              10
            );
        }
      }
      if (
        data.formData.degreeList &&
        data.formData.degreeList.length &&
        data.formData.degreeList.length > 0
      ) {
        this.form.topDegreeName =
          data.formData.degreeList[
            data.formData.degreeList.length - 1
          ].degreeName;
        this.form.degreeList.forEach((item) => {
          if (item.degreeDept && item.degreeDept === "其他") {
            item.isShowOtherDept = true;
          } else {
            item.isShowOtherDept = false;
          }
        });
      } else {
        this.form.topDegreeName = "无";
      }
    },
    // 照片加载
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/png";
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 png 格式!");
      }
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (!isLt1M) {
        this.$message.error("上传头像图片大小不能超过 1MB!");
      }
      return isJPG && isLt1M;
    },
    // 附件下载
    handleDownload(file) {
      const token = store.getters["user/accessToken"];
      downloadFile("/comm/file/downloadFile", { id: file.id, token: token });
    },
    // 不合适
    doUnSuit() {
      if (this.postSendId) {
        if (this.isOpen) {
          this.$confirm(
            "确认标记为不合适吗？将会给投递人发送简历不通过的邮件"
          ).then(async () => {
            unSuitResume({
              postSendId: this.postSendId,
              message: this.isOpen ? this.noFitMessage : "",
            }).then((res) => {
              if (res.success) {
                this.$message.success({
                  showClose: true,
                  message: "已标记为不合适!",
                  duration: messageDuration,
                });
                this.popVisible = false;
                this.unSuit = true;
              } else {
                this.$message.error(res.message);
              }
            });
          });
        } else {
          unSuitResume({
            postSendId: this.postSendId,
            message: this.isOpen ? this.noFitMessage : "",
          }).then((res) => {
            if (res.success) {
              this.$message.success({
                showClose: true,
                message: "已标记为不合适!",
                duration: messageDuration,
              });
              this.popVisible = false;
              this.unSuit = true;
            } else {
              this.$message.error(res.message);
            }
          });
        }
      } else {
        this.$message.warning("简历查询时，简历投递关联参数查询错误!");
      }
    },
    // 取消不合适
    doSuit() {
      if (this.postSendId) {
        suitResume({ postSendId: this.postSendId }).then((res) => {
          if (res.success) {
            this.$message.success({
              showClose: true,
              message: "已取消不合适标记!",
              duration: messageDuration,
            });
            this.unSuit = false;
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        this.$message.warning("简历查询时，简历投递关联参数查询错误!");
      }
    },
    // 收藏
    doCollect() {
      if (this.postSendId) {
        collectResume({
          postSendId: this.postSendId,
          userCode: this.userCode,
        }).then((res) => {
          if (res.success) {
            this.$message.success({
              showClose: true,
              message: "已收藏!",
              duration: messageDuration,
            });
            this.collected = true;
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        this.$message.warning("简历查询时，简历投递关联参数查询错误!");
      }
    },
    // 取消收藏
    doDisCollect() {
      if (this.postSendId) {
        unCollectResume({
          postSendId: this.postSendId,
          userCode: this.userCode,
        }).then((res) => {
          if (res.success) {
            this.$message.success({
              showClose: true,
              message: "已取消收藏!",
              duration: messageDuration,
            });
            this.collected = false;
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        this.$message.warning("简历查询时，简历投递关联参数查询错误!");
      }
    },
    back() {
      this.$router.back();
    },
    // 其他投递信息
    otherPost() {
      this.$router.push({
        path: "/otherResumeView/index",
        query: {
          resumeId: this.form.id,
        },
      });
    },
    // 分享
    share() {
      let message =
        this.form.name +
        "-" +
        this.$route.query.phase +
        "-" +
        this.$route.query.university +
        " 链接：" +
        developer +
        "/resumePDF/makeResumePDF.action?id=" +
        this.postSendId;
      let that = this;
      this.$copyText(message).then(
        function (e) {
          that.$message.success({
            showClose: true,
            message: "已复制链接到剪切板",
            duration: messageDuration,
          });
        },
        function (e) {
          that.$message.warning({
            showClose: true,
            message: "复制失败",
            duration: messageDuration,
          });
        }
      );
    },
  },
};
</script>

<style scoped lang="css">
.multipleSelect {
  width: 100%;
}
.el-button {
  margin-left: 10px;
  margin-bottom: 10px;
}
>>> .el-table {
  margin-bottom: 10px;
}
.spanTitle {
  margin-top: 10px;
  margin-bottom: 10px;
  font-weight: bold;
}
>>> .el-form-item__label {
  width: 100px;
}
>>> .avatar-uploader .el-upload {
  border: 2px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  float: right;
}
>>> .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
>>> .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 190px;
  line-height: 190px;
  text-align: center;
}
>>> .avatar {
  width: 150px;
  height: 190px;
  display: block;
}
input[type="file"] {
  display: none;
}
</style>

<style lang="css">
.avatar-uploader input[type="file"] {
  display: none;
}
input[type="file"] {
  display: none;
}

</style>
